export const APP_ROLE_PARAM_KEY = 'app-role';
